import { Card, Row, Col } from 'react-bootstrap'
import EditCard from './EditCard'
import DeleteCard from './DeleteCard'
import { useSelector } from 'react-redux'
import { useState } from 'react'

export default function EventsCard({ event, getEvents }) {
  const { user: authUser } = useSelector(x => x.auth)
  const [isEditing, setIsEditing] = useState(false)
  const isOfficer = authUser?.user.acl === "Officer"

  return (
    <Col xs={12} md={12} lg={12}>
      {isOfficer && isEditing ? (
        <>
          <EditCard
            event={event}
            getEvents={getEvents}
            showEditButton={false}
            onCancel={() => setIsEditing(false)}
            onSave={() => setIsEditing(false)}
          />
          <DeleteCard
            event={event}
            getEvents={getEvents}
            showDeleteButton={true}
            onDelete={() => setIsEditing(false)}
            onCancel={() => setIsEditing(false)}
          />
        </>
      ) : (
        <Card className="roles-card" id={`${event._id}-card`}>
          <Card.Header className="roles-card-header">
            <Card.Title>
              <h3>
                {event.name} <span style={{ fontSize: "14px" }}>{event.eventType}</span>
              </h3>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col xs={12} md={12} lg={12}>
                {event.title}
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div dangerouslySetInnerHTML={{ __html: event.description }}></div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div dangerouslySetInnerHTML={{ __html: event.subdescription }}></div>
              </Col>
            </Row>
            <Row>
              <Col style={{ backgroundColor: "#146c43", color: "#ffffff", textAlign: "center" }}>{event.green}</Col>
              <Col style={{ backgroundColor: "#ffc107", color: "#000000", textAlign: "center" }}>{event.amber}</Col>
              <Col style={{ backgroundColor: "#dc3545", color: "#ffffff", textAlign: "center" }}>{event.red}</Col>
              <Col style={{ backgroundColor: "#3498db", color: "#ffffff", textAlign: "center" }}>{event.total}</Col>
            </Row>
          </Card.Body>
          <Card.Footer>
            {isOfficer &&
              <Row>
                <Col xs={12} className="d-flex gap-2">
                  <EditCard
                    event={event}
                    getEvents={getEvents}
                    showEditButton={true}
                    onEdit={() => setIsEditing(true)}
                  />
                  <DeleteCard
                    event={event}
                    getEvents={getEvents}
                    showDeleteButton={true}
                    onDelete={() => getEvents()} // Refresh events after deletion
                  />
                </Col>
              </Row>
            }
          </Card.Footer>
        </Card>
      )}
    </Col>
  )
}